import React, { useState } from 'react'
import { BsChatDots } from 'react-icons/bs'
import FeedbackModal from './FeedbackModal'
import '../style/floatingIcons.css'

const FloatingIcons = () => {
  const [showFeedback, setShowFeedback] = useState(false)

  return (
    <>
      <div className="floating-icons">
        <button
          className="feedback-floating-btn"
          onClick={() => setShowFeedback(true)}
          title="Share your feedback"
        >
          <BsChatDots size={22} />
          <span className="feedback-label">Feedback</span>
        </button>
      </div>
      <FeedbackModal show={showFeedback} onClose={() => setShowFeedback(false)} />
    </>
  )
}

export default FloatingIcons
